import { Link } from "react-router-dom";
import { Home, ExternalLink, CreditCard, FileText } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const CompanyResourceLibrary = () => {
  const resources = [
    {
      title: "Employee Credit Card Authorization Request",
      description: "Submit your employee credit card authorization request form",
      url: "https://forms.gle/uddSX3sCh8vmZw148",
      icon: CreditCard,
      iconColor: "text-blue-600",
      bgColor: "bg-blue-100",
    },
    {
      title: "NFPA Codes",
      description: "Access NFPA codes and standards dashboard",
      url: "https://link.nfpa.org/dashboards/user",
      icon: FileText,
      iconColor: "text-orange-600",
      bgColor: "bg-orange-100",
    },
  ];

  return (
    <div className="space-y-6">
      {/* Breadcrumb */}
      <nav
        className="flex items-center text-sm text-muted-foreground mb-2"
        aria-label="Breadcrumb"
      >
        <Link
          to="/"
          className="hover:underline text-primary font-medium flex items-center"
        >
          <Home className="h-4 w-4 mr-1" />
        </Link>
        <span className="mx-2">/</span>
        <span className="text-foreground font-semibold">Company Resource Library</span>
      </nav>

      {/* Page Header */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Company Resource Library</h1>
        <p className="text-muted-foreground">
          Access important company resources and documentation
        </p>
      </div>

      {/* Resources Grid */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-2">
        {resources.map((resource) => {
          const Icon = resource.icon;
          return (
            <Card key={resource.title} className="hover:shadow-xl hover:scale-[1.02] transition-all duration-300 border-primary/5">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className={`p-3 rounded-2xl bg-primary/10 shadow-inner`}>
                    <Icon className={`h-6 w-6 text-primary`} />
                  </div>
                </div>
                <CardTitle className="mt-4 text-xl font-bold tracking-tight">{resource.title}</CardTitle>
                <CardDescription className="text-sm leading-relaxed text-muted-foreground/80">{resource.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <Button
                  asChild
                  className="w-full btn-gradient shadow-sophisticated"
                  variant="default"
                >
                  <a
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2"
                  >
                    Open Resource
                    <ExternalLink className="h-4 w-4" />
                  </a>
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default CompanyResourceLibrary;
